import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { getDescendantProp, isValidValue } from '@/utils';
import { EngineConcept, FuelType } from '@/store/modules/vmds/types';
import Modal from '../modal/modal.vue';
let EmissionComponent = class EmissionComponent extends Vue {
    translate;
    currentVehicle;
    currentEngineConcept;
    currentFuelTypes;
    currentEmissions;
    currentEngine;
    currentConsumption;
    emissionModalIsOpen = false;
    toggleEmissionModal() {
        this.emissionModalIsOpen = !this.emissionModalIsOpen;
    }
    replaceGenericInfo(vehicleName, rawText) {
        return rawText.replace('{{carModel}}', vehicleName);
    }
    getReplaceValues(rawText) {
        // Finds strings in the following format: {{someString}}
        const regex = /{{([\S\s]*?)}}/g;
        let valuesToReplace = [];
        const matches = rawText.match(regex) || [];
        for (const item of matches) {
            valuesToReplace.push({
                replacer: item,
                id: item.replace(/\{{|}}/g, ''),
            });
        }
        return valuesToReplace;
    }
    replaceWLTPValues(vehicleInfo, rawText) {
        this.getReplaceValues(rawText).forEach(({ id: itemId, replacer }) => {
            let property = getDescendantProp(itemId, vehicleInfo);
            if (!isValidValue(property)) {
                property = '-';
            }
            rawText = rawText.replace(replacer, property?.toString() || ' - ');
        });
        return rawText;
    }
    getEmissionText(engine, fuelTypes) {
        switch (engine) {
            case EngineConcept.COMBUSTION:
            case EngineConcept.MILD_HYBRID:
                if (fuelTypes.includes(FuelType.DIESEL)) {
                    return this.translate('wltp.diesel');
                }
                else {
                    return this.translate('wltp.petrol');
                }
            case EngineConcept.PLUGIN_HYBRID:
                return this.translate('wltp.hybrid');
            case EngineConcept.ELECTRIC:
                return this.translate('wltp.electric');
            default:
                return '';
        }
    }
    get emissionText() {
        let text = this.getEmissionText(this.currentEngineConcept, this.currentFuelTypes);
        text = this.replaceGenericInfo(this.currentVehicle.name, text);
        return this.replaceWLTPValues({
            emissions: this.currentEmissions,
            consumption: this.currentConsumption,
            engine: this.currentEngine,
        }, text);
    }
};
EmissionComponent = __decorate([
    Component({
        name: 'EmissionComponent',
        components: { Modal },
        computed: {
            ...mapGetters([
                'translate',
                'currentEngineConcept',
                'currentFuelTypes',
                'currentEmissions',
                'currentConsumption',
                'currentEngine',
                'currentVehicle',
            ]),
        },
    })
], EmissionComponent);
export default EmissionComponent;
